
import { Component, Prop, Mixins } from 'vue-property-decorator';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';

@Component
export default class HistoryControls extends Mixins(ResponsivenessMixin) {
  @Prop({ default: false }) onlyDelete!: boolean;

  @Prop({ default: false }) selectedItemsDeleted!: boolean;

  @Prop({ required: true }) selectedItemsCount!: number;
}
